import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import NewsCategoryPage from "@/pages/category/news/page";
import VideoCategoryPage from "@/pages/category/video/page";
import TopicCategoryPage from "@/pages/category/topic/page";
import DetailPage from "@/pages/detail/page";
import SpecialPage from "@/pages/special/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/news", element: <NewsCategoryPage /> },
      { path: "category/video", element: <VideoCategoryPage /> },
      { path: "category/topic", element: <TopicCategoryPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "special", element: <SpecialPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;